export default __webpack_public_path__ + "static/media/roboto_regular.a1cbff62.ttf";